import jwtDecode from "jwt-decode";

const baseUrl = "https://hisocars.techinnsoft.com";

export const userSignUp = async (value) => {
  console.log(value);
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(value);

  console.log("raw", raw);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${baseUrl}/api/Auth/register`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const userLogin = async (value) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(value);
  console.log(raw);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(`${baseUrl}/api/Auth/login`, requestOptions);
    console.log("data", response);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const GetTrendingBrands = async () => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-trending-brands`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("TrendingBranderror", error);
    return null;
  }
};
export const getHotOffers = async () => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-hot-offer`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getListings = async () => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-listings`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getListingImages = async (val) => {
  console.log("val", val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/car-list-photos?carListId=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const getListingBase64Images = async (val) => {
  console.log("val", val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Images/Get-Car-Image?CarListId=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const getSearchAreas = async (val) => {
  console.log(val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/search-car-locations?searchText=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getWishList = async (val) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-favourite?userId=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getListingReviews = async (val) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-listing-reviews?carListId=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const MarkFav = async (value, id) => {
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  console.log("val", value);
  console.log("id", id);

  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/mark-favourite?userId=${value}&carListId=${id}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const UnMarkFav = async (value, id) => {
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  console.log("val", value);
  console.log("id", id);

  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/remove-favourite?userId=${value}&carListId=${id}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const carBooking = async (item) => {
  console.log("item", item);
  const token = localStorage.getItem("token");
  const user = jwtDecode(token);
  console.log(user);
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    carListId: item.carListId,
    ownerId: item.ownerId,
    rentPerDay: item.rentPerDay,
    tripFeePerDay: item.tripFeePerDay,
    deliveryFee: item.deliveryFee,
    tax: item.tax,
    totalPrice: item.totalPrice,
    tripStartDate: item.tripStartDate,
    tripEndDate: item.tripEndDate,
    tripdays: item.tripdays,
    tripPickUpLocation: item.tripPickUpLocation,
    customerNotes: "Hello",
    tripDeliveryLocation: "Bangkok",
    user_Id: user.UserId,
    activeStatus: true,
  });

  console.log("raw", raw);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(`${baseUrl}/api/Booking`, requestOptions);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const carCheckOut = async (item) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    carListId: item.carListId,
    ownerId: item.ownerId,
    rentPerDay: item.rentPerDay,
    tripFeePerDay: item.tripFeePerDay,
    deliveryFee: item.deliveryFee,
    tax: item.tax,
    totalPrice: item.totalPrice,
    tripStartDate: item.tripStartDate,
    tripEndDate: item.tripEndDate,
    tripdays: item.tripdays,
    tripPickUpLocation: item.tripPickUpLocation,
    customerNotes: item.customerNotes,
    tripDeliveryLocation: item.tripDeliveryLocation,
    user_Id: item.user_Id,
    activeStatus: false,
  });
  console.log("raw", raw);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/update-booking?externalId=${item.bookingExternalId}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getListingsFeatures = async (val) => {
  console.log(val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-listing-feature?carListId=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getTrips = async (val) => {
  console.log("val", val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-trips-user-by-Status?userId=${val.userId}&status=${val.status}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const reportListings = async (obj) => {
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/Report-Listing?userId=${obj.userId}&carListId=${obj.carListId}&reportReason=${obj.reason}&notes=${obj.notes}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const contactUs = async (val) => {
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/contact-us?userId=guest&name=${val.userName}&message=${val.message}&number=${val.phone}&email=${val.email}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("err", error);
  }
};

export const getAreasList = async (val) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/search-location-list?searchText=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const changePass = async (val) => {
  console.log("val", val);
  const token = localStorage.getItem("token");
  const user = jwtDecode(token);
  console.log(user);
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Auth/change-password?userId=${user.UserId}&oldPassword=${val.oldPass}&newPassword=${val.pass}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const changeUserRole = async (val) => {
  console.log("val", val);
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Auth/become-a-host?userId=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const GetAllBrands = async () => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-all-brands`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const GetCarNames = async (val) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-specific-brand-cars?brandName=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getMessages = async (val) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-chat?userId=${val.userId}&carListId=${val.carListId}&ownerId=${val.ownerId}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const sendMessage = async (val) => {
  console.log("val", val);
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/send-message?userId=${val.userId}&textingUserId=${val.textingUserId}&carListId=${val.carListId}&ownerId=${val.ownerId}&message=${val.message}&chatDate=${val.chatDate}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getImage = async (val) => {
  console.log("val34", val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/ImagesWithUrl/Get-Profile-ImageUrl?userId=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const uploadListings = async (value) => {
  console.log("val", value);
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(value);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/upload-car-listing`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const uploadFeatures = async (value) => {
  console.log("val", value);
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(value);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/upload-cars-features`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export async function uriToBlob(uri) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function () {
      // return the blob
      resolve(xhr.response);
    };

    xhr.onerror = function () {
      // something went wrong
      reject(new Error("uriToBlob failed"));
    };
    // this helps us get a blob
    xhr.responseType = "blob";
    xhr.open("GET", uri, true);

    xhr.send(null);
  });
}
// export const saveImageToFirebase = async (res, folderName) => {
//   console.log('res', res);
//   try {
//     const today = new Date();
//     const milliseconds = today.getMilliseconds();
//     const timestamp = Date.parse(today) + milliseconds;
//     const imageName = `image_${timestamp}`;
//     let response = res;
//     let image = response.uri;
//     let imagePath = response.fileName + timestamp;

//     const file = await uriToBlob(image);
//     const uploadTask = storage.ref(`${folderName}/${imagePath}`).put(file);
//     uploadTask.on(
//       'state_changed',
//       snapshot => {
//         const progress = Math.round(
//           (snapshot.bytesTransferred / snapshot.totalBytes) * 100
//         );
//         if (progress == 100) {
//         }
//       },
//       error => {
//         console.log('error 1', error);
//       }
//     );
//     // Get the download URL of the uploaded image
//     const downloadURL = await downloadImage(`${folderName}`, imagePath);

//     return downloadURL;
//   } catch (error) {
//     console.error('Error saving image to Firebase:', error);
//     throw error;
//   }
// };
// export const postCarImages = async (id, item) => {
//   console.log("id", id);
//   console.log("item", item);
//   var formdata = new FormData();
//   formdata.append("image", item.uri);

//   var requestOptions = {
//     method: "POST",
//     body: formdata,
//     redirect: "follow",
//   };
//   try {
//     const response = await fetch(
//       `${baseUrl}/api/Images/Car-Image?carListId=${id}`,
//       requestOptions
//     );
//     const data = await response.text();
//     return data;
//   } catch (error) {
//     console.log("error", error);
//     return null;
//   }
// };
export const postCarImages = async (id, item) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/Images/Car-Image?carListId=${id}`,
      {
        method: "POST",
        body: createFormData(item),
        redirect: "follow",
      }
    );

    const data = await response.text();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

const createFormData = (item) => {
  const formData = new FormData();
  const uriParts = item.uri.split(".");
  const fileType = uriParts[uriParts.length - 1];

  formData.append("image", {
    uri: item.uri,
    name: `photo.${fileType}`,
    type: `image/${fileType}`,
  });

  return formData;
};
export const getHostCars = async (val) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    console.log("id@", val);
    const response = await fetch(
      `${baseUrl}/api/Host/get-car-listing-hostwise?ownerId=${val}`,
      requestOptions
    );
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getHostTrips = async (val, status) => {
  console.log("val", val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      // `${baseUrl}/api/Host/Get-Trips-Owner?ownerId=${val}`,
      `${baseUrl}/api/Host/Get-Trips-Owner-By-Host-Status?ownerId=${val}&bookingStatus=${status}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const postProfileImage = async (id, image) => {
  console.log(image);
  console.log("id", id);
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    imageUrlString: image,
    userId: id,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/ImagesWithUrl/profileimage`,
      requestOptions
    );
    const data = await response.text();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const updateProfile = async (val) => {
  console.log("val", val);
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    firstName: val.firstName,
    lastName: val.lastName,
    email: val.email,
    phoneNumber: val.phoneNumber,
  });
  console.log(raw);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Auth/update-user-info?userId=${val.userId}`,
      requestOptions
    );
    console.log("response", response);
    const data = await response.json();
    console.log("json", data);
    return data;
  } catch (error) {
    console.log("error222", error);
    return null;
  }
};
export const getFilteredList = async (val) => {
  console.log("val", val);
  const obj = {
    MaxPrice: parseInt(val.MaxPrice),
    MinPrice: parseInt(val.MinPrice),
    brand: val.brand,
    location: val.location,
  };
  console.log("obj", obj);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-filter-listings?carbrand=${obj.brand}&maxPrice=${obj.MaxPrice}&minPrice=${obj.MinPrice}&location=${obj.location}`,
      requestOptions
    );
    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getBookingImages = async (val) => {
  console.log("val", val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/ImagesWithUrl/Get-Booking-Image?BookingId=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const getBookingImagesHost = async (val) => {
  console.log("val", val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/ImagesWithUrl/Get-Bookingimage-By-Host?BookingId=${val}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const postCheckOutImage = async (val) => {
  var formdata = new FormData();
  formdata.append("file", {
    uri: val.uri,
    name: val.name,
    type: val.type,
  });

  var requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Images/Booking-Image-Uplaod?bookingId=${val.id}&PicNo=${val.no}`,
      requestOptions
    );
    console.log("res", response);
    const data = await response.text();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const posthostCarImageurls = async (imageUrl, carListId) => {
  console.log(
    "abc",
    `${baseUrl}/api/ImagesWithUrl/Car-Image-by-url?carImageUrl=${imageUrl}&carListId=${carListId}`
  );
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    url: imageUrl,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/ImagesWithUrl/Car-Image-by-url?carListId=${carListId}`,
      requestOptions
    );
    console.log("res", response);
    const data = await response.text();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const postUserBookingImagesUrls = async (bookingId, item) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(item);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/ImagesWithUrl/Booking-Image-Uplaod-With-Url?bookingId=${bookingId}`,
      requestOptions
    );
    console.log("res", response);
    const data = await response.text();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const postHostBookingImagesUrls = async (bookingId, item) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(item);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/ImagesWithUrl/Upload-Car-Images-By-Host?bookingId=${bookingId}`,
      requestOptions
    );
    console.log("res", response);
    const data = await response.text();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const PostLisenceinfo = async (obj) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(obj);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/add-license`,
      requestOptions
    );
    console.log("res", response);
    const data = await response.text();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const getNotifications = async (val) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-all-notifications?userId=${val}`,
      requestOptions
    );
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const sendNotifications = async (item) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(item);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/send-notifications`,
      requestOptions
    );
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const getProfileStatus = async (val) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Auth/profile-status-check?UserId=${val}`,
      requestOptions
    );
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getLisenceInfo = async (val) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/get-license-by-user?userId=${val}`,
      requestOptions
    );
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const ChangeBookingStatus = async (val) => {
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/Update-Booking-Status?externalId=${val.bookingExternalId}&bookingStatus=${val.bookingStatus}`,
      requestOptions
    );
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const addAreas = async (item) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(item);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/add-location`,
      requestOptions
    );
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const UpdateTripCount = async (val) => {
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/Update-Booking-Status?externalId=${val.bookingExternalId}&bookingStatus=${val.bookingStatus}`,
      requestOptions
    );
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const RemoveBookingDates = async (val) => {
  var requestOptions = {
    method: "POST",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Booking/remove-booking-calender?externalId=${val}`,
      requestOptions
    );
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const getTopHosts = async (val) => {
  console.log(val);
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  try {
    const response = await fetch(
      `${baseUrl}/api/Auth/top-rated-host`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
